<template>
  <div
    :class="[
      'model-history',
      { 'lp-p-t': noMargin },
      { 'no-padding-top ': noPadding },
    ]"
  >
    <ModelSimilar
      :similar="models"
      :font-class="fontClass"
      title="Ранее вы смотрели"
      :model-id="0"
      :page-data="[]"
      full-width-mobile
    />
  </div>
</template>

<script lang="ts" setup>
import type { ResponseModel } from '~/interfaces/api';
import { useHistoryStore } from '~/stores/history';
import { useInteractiveStore } from '~/stores/interactive';

const props = defineProps({
  limit: {
    type: Number,
    default: 1000,
  },
  noMargin: {
    type: Boolean,
    default: true,
  },
  noPadding: {
    type: Boolean,
    default: false,
  },
  // для загрузки сразу, а не после первого интерактива
  isFast: {
    type: Boolean,
    default: false,
  },
  fontClass: {
    type: String,
    default: 'heading-m',
  },
});
const historyStore = useHistoryStore();
const interactiveStore = useInteractiveStore();
const models = computed<ResponseModel[]>(() => historyStore.histories);
onBeforeMount(() => {
  if (props.isFast && !import.meta.env.SSR) {
    historyStore.getHistoryEnvironment();
  } else {
    interactiveStore.addFunction(historyStore.getHistoryEnvironment);
  }
});
</script>

<style scoped lang="scss">
.no-padding-top {
  padding-top: 0 !important;
}
</style>
